var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEraserFill = function SvgIconEraserFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.776 15.5h3.968v1.083h-5.052zm-8.96 1.083-2.162-2.161a1.32 1.32 0 0 1-.408-.932q-.01-.535.408-.953L11.28 3.91q.418-.418.946-.414t.946.422l3.652 3.653q.397.397.412.935.015.54-.404.957l-7.12 7.12z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEraserFill);
export { ForwardRef as ReactComponent };